import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './_images/banner.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-e2f29f2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "590",
  height: "350",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "upload-idle" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cm-ui-mt10" }, "拖入您的同步授权文件，或点击选择文件", -1))
const _hoisted_6 = {
  key: 1,
  class: "upload-uploading"
}
const _hoisted_7 = {
  key: 0,
  class: "text"
}
const _hoisted_8 = {
  key: 1,
  class: "text"
}
const _hoisted_9 = {
  key: 2,
  class: "upload-success"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success-text" }, "云特征库同步成功", -1))
const _hoisted_11 = {
  key: 3,
  class: "upload-fail"
}
const _hoisted_12 = { class: "fail-text" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "bt cm-ui-mt30" }
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h2", null, _toDisplayString(_ctx.brandConfig.client_name) + "-云特征离线库同步工具", 1)
    ]),
    (_ctx.viewModel.state === _ctx.STATE.IDLE)
      ? (_openBlock(), _createBlock(_component_el_upload, {
          key: 0,
          ref: "uploadNode",
          class: "upload-file",
          drag: "",
          action: "/sample/update/offline_virus_database",
          disabled: !_ctx.viewModel.permitToken,
          name: "file",
          limit: 1,
          "show-file-list": false,
          "http-request": _ctx.handleHttpUpload,
          onChange: _ctx.handleChange
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_CmSvgIcon, {
                class: "icon-plus",
                name: "views/cloud-library-update/_images/plus",
                monochrome: "",
                size: 20
              }),
              _hoisted_5
            ])
          ]),
          _: 1
        }, 8, ["disabled", "http-request", "onChange"]))
      : ([_ctx.STATE.UPLOADING, _ctx.STATE.UPDATING].includes(_ctx.viewModel.state))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.viewModel.state === _ctx.STATE.UPLOADING)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createTextVNode("正在上传授权文件 - "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.viewModel.fileName), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.viewModel.taskStatusMessage), 1)),
            _createVNode(_component_el_progress, {
              percentage: _ctx.viewModel.percentage,
              indeterminate: _ctx.viewModel.state === _ctx.STATE.UPDATING,
              "stroke-width": 6,
              class: "progress-color"
            }, null, 8, ["percentage", "indeterminate"])
          ]))
        : (_ctx.viewModel.state === _ctx.STATE.SUCCESS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_CmSvgIcon, {
                class: "icon-success",
                name: "views/cloud-library-update/_images/success",
                monochrome: "",
                size: 24
              }),
              _hoisted_10,
              _createElementVNode("p", null, "授权文件：" + _toDisplayString(_ctx.viewModel.fileName), 1)
            ]))
          : (_ctx.viewModel.state === _ctx.STATE.FAIL)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_CmSvgIcon, {
                  class: "icon-fail",
                  name: "views/cloud-library-update/_images/fail",
                  monochrome: "",
                  size: 24
                }),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.viewModel.errorMsg), 1),
                (_ctx.viewModel.fileName)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, "授权文件：" + _toDisplayString(_ctx.viewModel.fileName), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      (_ctx.viewModel.libraryFilePath)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _ctx.viewModel.libraryFilePath,
            target: "_blank"
          }, [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withCtx(() => [
                _createVNode(_component_CmSvgIcon, {
                  class: "icon-download",
                  name: "views/cloud-library-update/_images/download",
                  color: "#fff",
                  size: 14
                }),
                _createTextVNode("下载更新包")
              ]),
              _: 1
            })
          ], 8, _hoisted_15))
        : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CmSvgIcon, {
                class: "icon-download",
                name: "views/cloud-library-update/_images/download",
                color: "#fff",
                size: 14
              }),
              _createTextVNode("下载更新包")
            ]),
            _: 1
          }))
    ])
  ]))
}